import React from "react"
import { graphql } from "gatsby"
import Layout from "../../components/Layout/layout"
import SEO from "../../components/seo"
import {
  listGdd,
  titleGdd,
  homeLogo,
  imgLogo,
  backContainer,
  backToSite,
  backLink,
} from "./styles/listGdd.module.scss"
import PropTypes from "prop-types"
import { StyledSection, BandeauStyled } from "./styled-components/gdd-styled"
import { useBuildData } from "../../hooks/use-build-data"
import Icon from "../../components/Icon/icon"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import ImageFromDrupal from "../../components/Image/image-from-drupal"
import ReactHtmlParser, { processNodes } from "react-html-parser"

//-----------------------QueryGraphql---------------------------//

export const query = graphql`
  query($regex: String!) {
    asciidoc(path: { alias: { regex: $regex } }) {
      html
      document {
        title
      }
    }
  }
`
//-----------------------QueryGraphql---------------------------//

//-----------------------Component---------------------------//

const HtmlParser = ({ content }) => {
  return new ReactHtmlParser(content, {
    transform: function transform(node, elementIndex) {
      if (
        node.type === "tag" &&
        node.name === "div" &&
        node.attribs.class === "sect1"
      ) {
        return (
          <StyledSection key={elementIndex} className={listGdd}>
            <div>{processNodes(node.children, transform)}</div>
          </StyledSection>
        )
      }
      if (node.type === "tag" && node.name === "li") {
        return (
          <React.Fragment key={elementIndex}>
            <li tabIndex={elementIndex}>
              {processNodes(node.children, transform)}
            </li>
          </React.Fragment>
        )
      }
    },
  })
}

const GddTemplate = ({ data }) => {
  const buildColors = useBuildData().theme_settings.palette
  const buildInfos = useBuildData().site_settings
  return (
    <Layout isGdd={true} message="Guide des droits et démarches">
      <SEO
        title={data.asciidoc.document.title}
        description={data.asciidoc.document.title}
      />
      <div className="headerGDD">
        <AniLink
          aria-label="Logo d'accueil"
          className={backLink}
          paintDrip
          hex={buildColors.a_color_gradients.a_dark}
          to="/"
        >
          {buildInfos.website_logo.fid === null ? (
            <div className={backContainer}>
              <Icon className={homeLogo} size={24} icon="home" />
              <p className={backToSite}>Retour au site</p>
            </div>
          ) : (
            <ImageFromDrupal
              className={imgLogo}
              alt={"Logo " + buildInfos.website_name}
              drupal_fid={buildInfos.website_logo.fid}
            />
          )}
        </AniLink>
        <h1 className={titleGdd}>
          GUIDE<br></br>« VOS DROITS ET DÉMARCHES »<br></br>POUR LES
          PARTICULIERS
        </h1>
        <BandeauStyled />
      </div>
      <HtmlParser content={data.asciidoc.html} />
    </Layout>
  )
}

//-----------------------Component---------------------------//

//-----------------------Prop-Types---------------------------//

GddTemplate.propTypes = {
  data: PropTypes.object.isRequired,
}

//-----------------------Prop-Types---------------------------//

export default GddTemplate
